// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ll_f","content":"styles_content__3g_bl","row":"styles_row__l7slI","footer":"styles_footer__3C43o","phraseLength":"styles_phraseLength__u60_-"};